import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { CartProvider } from "./components/CartContext";
import {Cart} from "./components/Cart";
import {HomePage} from "./components/HomePage";
import BuyACopy from "./components/BuyACopy";
import ProductList from "./components/ProductList";
import {Checkout} from "./components/Checkout";
import {Gallery} from "./components/Gallery";
import {ComicReader} from "./components/ComicReader";
import {ReaderAuthenticate} from "./components/ReaderAuthenticate";
import {ThankYou} from "./components/ThankYou";
import DownloadPage from "./components/DownloadPage";
const App = () => {
  return (
    <CartProvider>
    <Router>
      {/* <RouteChangeTracker /> */}
      <div>
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route exact path="/buy" render={() => <Redirect to="/buy/nandi-book" />} />
          <Route path="/buy/:productId" component={BuyACopy} />
          <Route path="/products" component={ProductList} />
          <Route path="/cart" component={Cart} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/download/:token" component={DownloadPage} />
          <Route path="/read" component={ComicReader}/>
          <Route path="/readerAuth" component={ReaderAuthenticate}/>
          <Route path="/thank-you" component={ThankYou}/>
          <Route path="/gallery" component={Gallery} />
        </Switch>
      </div>
    </Router>
    </CartProvider>
  );
};

export default App;

